var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid meeting-agenda" },
    [
      _vm.loaders.agendas
        ? _c(
            "div",
            { staticClass: "loading-indicator" },
            [_c("MoonLoader", { attrs: { size: "75px", color: "#ffffff" } })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.agendas && _vm.currentAgenda
        ? _c("div", [
            _c("div", { staticClass: "grid" }, [
              _c(
                "div",
                {
                  staticClass:
                    "grid__col--12 meeting-agenda__title h-center-align"
                },
                [_vm._v(_vm._s(_vm.currentAgenda.title))]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "grid" }, [
              _c(
                "div",
                {
                  staticClass:
                    "grid__col--12 meeting-agenda__sub-title h-center-align"
                },
                [_vm._v(_vm._s(_vm.currentAgenda.meeting_date))]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "panel grid meeting-agenda__detail-container h-flex-container"
              },
              [
                _vm.currentAgenda.description !== ""
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "grid__col--5 meeting-agenda__description-section h-flex-item"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "meeting-agenda__description" },
                          [
                            _c(
                              "div",
                              { staticClass: "meeting-agenda__item-title" },
                              [_vm._v("Description")]
                            ),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "meeting-agenda__item-content",
                              domProps: {
                                innerHTML: _vm._s(_vm.currentAgenda.description)
                              }
                            })
                          ]
                        )
                      ]
                    )
                  : _c("div", { staticClass: "grid__col--2--half" }),
                _vm._v(" "),
                _c("div", { staticClass: "grid__col--7 h-no-margin" }, [
                  _c("div", { staticClass: "grid h-flex-container" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "grid__col--3 meeting-agenda__attendees-section h-flex-item"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "meeting-agenda__attendees-list" },
                          [
                            _c(
                              "div",
                              { staticClass: "meeting-agenda__item-title" },
                              [_vm._v("Attendees")]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.contactAttendeesList, function(
                              contact,
                              index
                            ) {
                              return _c(
                                "div",
                                { staticClass: "meeting-agenda__item-content" },
                                [_vm._v(_vm._s(contact.name))]
                              )
                            })
                          ],
                          2
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "grid__col--3 meeting-agenda__attendees-section h-flex-item"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "meeting-agenda__attendees-list" },
                          [
                            _c(
                              "div",
                              { staticClass: "meeting-agenda__item-title" },
                              [_vm._v("Fuel Attendees")]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.fuelUserAttendeesList, function(
                              fuelUser,
                              index
                            ) {
                              return _c(
                                "div",
                                { staticClass: "meeting-agenda__item-content" },
                                [_vm._v(_vm._s(fuelUser.name))]
                              )
                            })
                          ],
                          2
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "grid__col--3 meeting-agenda__attendees-section h-flex-item"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "meeting-agenda__attendees-list" },
                          [
                            _c(
                              "div",
                              { staticClass: "meeting-agenda__item-title" },
                              [_vm._v("Other Attendees")]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.otherAttendeesList, function(
                              other,
                              index
                            ) {
                              return _c(
                                "div",
                                { staticClass: "meeting-agenda__item-content" },
                                [_vm._v(_vm._s(other.name))]
                              )
                            })
                          ],
                          2
                        )
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm.currentAgenda.description === ""
                  ? _c("div", { staticClass: "grid__col--2--half" })
                  : _vm._e()
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.agendas
        ? _c("AgendaContainer", { attrs: { agenda: _vm.currentAgenda } })
        : _vm._e(),
      _vm._v(" "),
      _vm.modalActive ? _c("AgendaItemModal") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }